import React, { useMemo } from 'react';
import { Table } from 'antd';
import { DataTableModel, getApplicationListRespModel } from '../../Models/tableDetailsModel';
import { TablePagination } from '@mui/material';
import { rowCountPerPage, rowCountPerPageOptions } from '../../constants/rowsPerPageOptions';
import { customDataTableStyle } from './customDataTableStyle';
import styles from "./customDataTableStyles.module.css";
import { columnNameToExcludeInUI } from "../../constants/InsightPageColumnsInfo";
import { EmptyTblContainer } from '../emptyTblContainer/emptyTblContainer.index';

interface DataTableProps {
  columns: DataTableModel[];
  rows: getApplicationListRespModel[];
  totalRowsCount: number;
  pageNo: number;
  handleChangePage: (rowsPerPage: any, newPage: any) => void;
  rowsPerPage: rowCountPerPage;
  setRowsPerPage: React.Dispatch<React.SetStateAction<rowCountPerPage>>;
  handleRowPerPageChange: (oldRowPerPage: number, newRowPerPage: number, pageNo: number) => Promise<void>;
  tableBodyRef: React.MutableRefObject<HTMLTableSectionElement | null>;
  visibleColumns: string[] | null;
}

const CustomDataTable: React.FC<DataTableProps> = (props) => {

  const {
    columns,
    rows,
    totalRowsCount,
    pageNo,
    rowsPerPage,
    handleRowPerPageChange,
    tableBodyRef,
    visibleColumns
  } = props;

  const {
    tablePaginationStyle
  } = customDataTableStyle().classes

  const handleChangeRowsPerPageHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    // Handle for the filter values.(If any)
    let newRowPerPages = +event.target.value as rowCountPerPage;
    let oldRowsPerPage = rowsPerPage;
    handleRowPerPageChange(oldRowsPerPage, newRowPerPages, pageNo);
  };

  const filteredColumns = useMemo(
    () =>
      visibleColumns === null
        ? columns
        : columns.filter(
            (col) =>
              visibleColumns.includes(col.key) ||
              columnNameToExcludeInUI.includes(col.key)
          ),
    [columns, visibleColumns]
  );


  // @ts-ignore
  return (
    <>
      <Table
        size='middle'
        columns={filteredColumns}
        dataSource={rows}
        bordered
        scroll={{ y: "calc(100vh - 280px)", x: 'max-content' }}
        pagination={false}
        rowClassName={(_, index) =>
            index % 2 === 0 ? styles.evenRow : styles.oddRow
        }
        className={styles.customTable}
        components={{
          header: {
            cell: ({
                     className,
                     ...restProps
                   }: React.ThHTMLAttributes<HTMLTableCellElement>) => (
                <th
                    {...restProps}
                    className={`${className} ${styles.header}`}
                />
            ),
          },
          body: {
            wrapper: (props: React.HTMLAttributes<HTMLTableSectionElement>) => (
              <tbody {...props} ref={tableBodyRef} />
            ),
          },
        }}
        locale={{
          emptyText: <EmptyTblContainer description="No Applications Found" />,
        }}
      />
      <TablePagination
        rowsPerPageOptions={rowCountPerPageOptions}
        component="div"
        count={totalRowsCount}
        rowsPerPage={rowsPerPage}
        page={(pageNo - 1)}
        onPageChange={(event, newPage) => {
          // It use Zero based index but we are using the 1 based index in the backend.
          props.handleChangePage(rowsPerPage, newPage + 1)
        }}
        onRowsPerPageChange={handleChangeRowsPerPageHandler}
        className={tablePaginationStyle}
      />
    </>

  );
};

export default CustomDataTable;